// Workstation — v1.1 §4. Built in Steps 5, 6 and 10.
//
// THIS IS A STUB. The session that builds the Workstation edits this file and
// its own modules beside it, never `App.js`.
//
// §3.6 calls this "the largest relocation" in the migration. Everything that
// lands here already runs somewhere in the tree today; nothing on this surface
// is a new capability (§0).
//
// A2 — ONE WORKSTATION, NOT TWO
// =============================
// Q4 says the ABH Campaign Workstation is "the same shell"; §4 is written
// throughout in terms of *the* Offer Workstation. The proposed reading, and
// what this stub is built for: ONE Workstation area whose content is determined
// by the selected offer or campaign. That satisfies "same shell" literally and
// keeps the Y-axis at exactly five entries per §2. The object switcher lives in
// the appbar's left slot, which is where SHELL.md puts the live object.
//
// A3 — OPPORTUNITIES *DOES* HAVE DATA (this comment was wrong)
// ============================================================
// This block used to read "no endpoint identifiably serves it; the tab is
// reserved and renders the empty state." That was inherited from §4 of the
// build instruction and it was incorrect.
//
// `design/system/audits/workstation-tabs.md` audited all eight tabs and found
// backing endpoints for every one of them, Opportunities included, offer-scoped.
// NO WORKSTATION TAB IS `NONE`. Build this tab against its endpoints like any
// other; do not render a permanent empty state here on the assumption that
// nothing serves it.
//
// Still true, and unchanged: do not build a *backend* for any tab — that is R4.
//
// ALL EIGHT TABS ARE BUILT
// ===========================================
// Overview (§4.1), Analytics (§4.2), Opportunities (WORKSTATION-OPPORTUNITIES-
// APPROVED) and, per H5-H9-WORKSTATION-TABS (docs/DECISION_LOG.md
// READY-NOW-BATCH-APPROVED), the remaining five — Research & Audience,
// Landing Pages, Ads & Creative, Traffic Channels, Learnings — all render
// real surfaces from real, live, unflagged endpoints. Each tab's own file
// header cites the `design/system/audits/workstation-tabs.md` section and
// the exact `file:line`s it reads. Two genuine backend gaps are rendered as
// labelled placeholders inside otherwise-real tabs rather than as a whole
// stubbed tab: Landing Pages' page-heatmap block (no capture tooling exists
// anywhere in the tree) and Analytics · Individual's ad-grain rankings (no
// router reads `ad_performance_snapshots`). Neither is a new tab-level stub.
//
// This file stays a dispatcher. Everything each tab needs lives in
// `routes/workstation/`, which is this lane's own folder.
import React from "react";

import { useShell } from "../ShellContext";
import AdsCreative from "./workstation/AdsCreative";
import Analytics from "./workstation/Analytics";
import Compliance from "./workstation/Compliance";
import LandingPages from "./workstation/LandingPages";
import Learnings from "./workstation/Learnings";
import Opportunities from "./workstation/Opportunities";
import Overview from "./workstation/Overview";
import Research from "./workstation/Research";
import Audience from "./workstation/Audience";
import TrafficChannels from "./workstation/TrafficChannels";
import { useOfferSelection } from "./workstation/useOffer";
import "./workstation/workstation.css";

export default function WorkstationArea() {
  const { tab } = useShell();

  // The offer selection is resolved ONCE, here, and handed to whichever tab is
  // showing, so switching tabs keeps the offer and neither tab owns it.
  //
  // Called unconditionally, before any branch: it is a hook, and a hook behind
  // an `if` is the rules-of-hooks violation that breaks on the first tab
  // change. Learnings does not use it (it is not offer-scoped, per its own
  // header comment) but every other tab does, so it is still resolved here
  // rather than each tab re-deriving its own.
  const selection = useOfferSelection();

  if (!tab) return <Overview selection={selection} />;
  if (tab === "analytics") return <Analytics selection={selection} />;
  if (tab === "opportunities") return <Opportunities selection={selection} />;
  if (tab === "research") return <Research selection={selection} />;
  if (tab === "audience") return <Audience selection={selection} />;
  if (tab === "landing-pages") return <LandingPages selection={selection} />;
  if (tab === "creative") return <AdsCreative selection={selection} />;
  if (tab === "traffic") return <TrafficChannels selection={selection} />;
  if (tab === "compliance") return <Compliance selection={selection} />;
  if (tab === "learnings") return <Learnings />;

  return <Overview selection={selection} />;
}
